<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="row">
            <div class="col-md-12 rolelist" v-if="Auth.role == 1">
                <div class="addrole">
                    <!-- <router-link to="/admin/dashboard/addrole">
                        <b-button>Add Role</b-button>
                    </router-link> -->
                    <router-link to="/admin/dashboard/addrole"><a class="">Add Role</a></router-link>
                </div>
            </div>

            <div class="col-md-12 rolelistupper">
                <div class="card">
                     <h5 class="card-title">Role List</h5>
                    <FlashMessage :position="'right top'"></FlashMessage>

                    <div class="card-body table-responsive table-full-width">

                        <table class="table table-borderd mt-5" id="myTable">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Role</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="data in tableData" v-bind:key="data.roleid">
                                    <td>{{data.roleid}}</td>
                                    <td>{{data.role}}</td>
                                    <td>{{data.status}}</td>
                                    <td><button @click.prevent="deleteData(data.roleid)" class="btnborderremove">
                                            <a><b-icon-trash></b-icon-trash></a>
                                        </button>&nbsp; &nbsp; <router-link :to="'/admin/dashboard/editrole/' + data.roleid"><button class="btnborderremove">
                                            <a><b-icon-pencil-square></b-icon-pencil-square></a>
                                            </button></router-link>
                                    </td>

                                </tr>
                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import datatable from "datatables.net-bs4"
import Auth from '../../../Auth.js';
import Vue from 'vue'
import $ from "jquery"
import {
    Table,
    TableColumn
} from 'element-ui'
Vue.use(Table)
Vue.use(TableColumn)
export default {
    name: 'listRole',

    components: {
        TopNavbar,
        ContentFooter,
    },

    data() {
        return {
            tableData: [],
            Auth: '',
        }
    },

    methods: {

        table() {
            this.$nextTick(() => {
                $('#myTable').DataTable();
            });
        },

        getData() {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/role`).then((res) => {
                this.tableData = res.data;
                this.table();

            });
        },

        deleteData(roleid) {
            this.axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/role/delete/` + roleid).then((res) => {
                this.getData();
                this.flashMessage.success({
                    message: 'Role Deleted Successfully'
                });
            });
        },

    },

    mounted() {
        this.getData();
        this.Auth = Auth.user;
    },

};
</script>

<style lang="scss">

</style>
